/**
 * Copyright Mántum All Rights Reserved.
 */
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

import type { Type } from '@mantum/kanela';

type PropTypes = {
    children?: React.ReactNode;
    error?: boolean;
    message?: string;
    mutate?: boolean;
    type: Type;
};

export default function Validator(props: PropTypes) {
    const right =
        props.type === 'select' ||
        props.type === 'date' ||
        props.type === 'password'
            ? 'right-[46px]'
            : 'right-2';

    const top = props.type !== 'datatable' ? 'top-2.5' : 'top-2';

    const bgColor = props.type !== 'file' ? 'bg-white' : 'transparent';

    const mutate = props.mutate ? 'flex-col items-center' : ' items-start';

    return (
        <>
            <div className={`relative flex ${mutate}`}>
                {props.children}
                {props.error && (
                    <ExclamationCircleIcon
                        className={`absolute rounded-full ${right} ${top} h-5 w-5 ${bgColor} text-error`}
                    />
                )}
            </div>
            {props.error && props.message && (
                <small className='pl-2 pt-1 text-sm text-error'>
                    {props.message}
                </small>
            )}
        </>
    );
}
